<template>
  <div class="detail-container">
    <div class="detail-header">
      <span class="detail-title">{{ decryptLabel(noticeDetail.title) }}</span>
      <span class="detail-date">{{ noticeDetail.date }}</span>
    </div>
    
    <div class="detail-content">
      <span class="detail-text">{{ noticeDetail.content }}</span>
    </div>
    
    <button class="back-btn" @click="goBack">返回</button>
  </div>
</template>

<script>
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      noticeDetail: {
        id: 0,
        title: '',
        date: '',
        content: ''
      },
      noticeContents: {
        1: {
          id: 1,
          title: 'qTLrwxK8TFwM8ApMHTtn/RZ9kpWRSQPTQNkwKXR/v/6qzH3B1/Qz+XLTwf43fXEx',
          date: '2023-05-15',
          content: '尊敬的客户：\n\n为更好地服务广大用户，我行决定自2023年6月1日起对部分贷款产品的利率进行调整。具体调整方案如下：\n\n1. 个人消费贷款利率下调0.5个百分点\n2. 企业经营贷款利率维持不变\n3. 新增专项优惠利率产品\n\n详情请咨询客服热线：400-123-4567\n\n感谢您的支持与理解！'
        },
        2: {
          id: 2,
          title: 'UQxQP4B5bQveOpyXwHEnwCOBrmESSmzRLmqwSk7LanE=',
          date: '2023-05-10',
          content: '系统维护通知：\n\n为提升系统性能，我行将于2023年5月15日00:00至06:00进行系统维护。在此期间，手机银行、网上银行等服务将暂停使用。\n\n请您提前安排好相关业务办理，给您带来的不便敬请谅解。'
        },
        3: {
          id: 3,
          title: 'QQ45qiljUndupW49hkvV5V+woaIslEjoYxr0l/4fy+g=',
          date: '2023-05-05',
          content: '好消息！即日起，我行新增支付宝还款渠道。您可以通过支付宝搜索"XX银行"生活号进行还款操作，享受更便捷的还款体验。\n\n还款步骤：\n1. 打开支付宝APP\n2. 搜索"XX银行"生活号\n3. 绑定您的贷款账户\n4. 选择还款金额并确认支付\n\n如有疑问，请联系客服。'
        },
        4: {
          id: 4,
          title: 'KmUHKgwR1QzIEEQDwe7MTu8wjoAprIUDSuOS7lYX0MI=',
          date: '2023-04-25',
          content: '用户协议更新说明：\n\n为适应监管要求和服务升级，我行对《用户服务协议》和《隐私政策》进行了更新。主要变更内容包括：\n\n1. 增加数据安全保障条款\n2. 优化服务流程描述\n3. 明确用户权利和义务\n\n更新后的协议将于2023年5月1日正式生效，请您仔细阅读。'
        },
        5: {
          id: 5,
          title: 'SoSd3jfpZdGHOUm0RXn83yGi8t2ei64GAb79r/O+xD4=',
          date: '2023-04-20',
          content: '五一劳动节服务安排：\n\n根据国家法定节假日安排，2023年五一劳动节期间（4月29日-5月3日）我行服务安排如下：\n\n1. 线上服务：24小时正常运营\n2. 客服热线：9:00-18:00\n3. 线下网点：5月1日休息，其他时间正常营业\n\n祝您节日快乐！'
        }
      }
    }
  },
  
  created() {
    const id = this.$route.query.id
    if (id) {
      const noticeId = parseInt(id)
      this.loadNoticeDetail(noticeId)
    }
  },
  
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    loadNoticeDetail(id) {
      const detail = this.noticeContents[id]
      if (detail) {
        this.noticeDetail = detail
      } else {
        this.$error('文章不存在').then(() => {
          this.goBack()
        })
      }
    },
    
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.detail-container {
  padding: 20px;
  background-color: #ffffff;
  min-height: 100vh;
}

.detail-header {
  margin-bottom: 30px;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 15px;
}

.detail-title {
  display: block;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
}

.detail-date {
  font-size: 14px;
  color: #999;
}

.detail-content {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.detail-text {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  white-space: pre-line;
}

.back-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #ff9800;
  color: #fff;
  border-radius: 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
</style>
